import { cn } from '@/shared/lib/utils';
import { Lock } from 'lucide-react';
import React from 'react';

interface StepLockedSectionProps {
  locked: boolean;
  lockTitle: string;
  lockDescription: string;
  minHeight?: number;
  children: React.ReactNode;
}

export const StepLockedSection: React.FC<StepLockedSectionProps> = ({
  locked,
  lockTitle,
  lockDescription,
  minHeight = 160,
  children,
}) => (
  <div className="relative" style={{ minHeight: locked ? minHeight : undefined }}>
    {children}
    {locked && (
      <div
        className={cn(
          'absolute inset-0 z-10 flex flex-col items-center justify-center gap-2',
          'rounded-12 border border-dashed bg-background/80 backdrop-blur-[1px]',
        )}
      >
        <Lock className="h-5 w-5 text-muted-foreground" />
        <p className="text-sm font-medium">{lockTitle}</p>
        <p className="max-w-md px-4 text-center text-xs text-muted-foreground">
          {lockDescription}
        </p>
      </div>
    )}
  </div>
);
